import _ from 'underscore';

import GroupScope from './GroupScope';

class GroupSummary {
  constructor(data: $TSFixMe) {
    Object.assign(
      this,
      _(data).pick(
        'id',
        'name',
        'slug',
        'pendingMembersCount',
        'confirmedMembersCount',
        'totalMembersCount',
        'isArchived',
        'scopeType',
        'scopeId',
        'partnerIds'
      )
    );

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'scope' does not exist on type 'GroupSumm... Remove this comment to see the full error message
    this.scope = new GroupScope({ name: data.scopeType, id: data.scopeId });
  }
}

export default GroupSummary;
